/*!
 * FastClick: polyfill to remove click delay on browsers with touch UIs.
 * Version modified to ignore inputs for focus issues on mobile.
 */

!function() {
  "use strict";

  function FastClick(layer, options) {
    var oldOnClick;

    options = options || {};

    this.trackingClick = false;
    this.trackingClickStart = 0;
    this.targetElement = null;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.lastTouchIdentifier = 0;
    this.touchBoundary = options.touchBoundary || 10;
    this.layer = layer;
    this.tapDelay = options.tapDelay || 200;
    this.tapTimeout = options.tapTimeout || 700;

    if (FastClick.notNeeded(layer)) {
      return;
    }

    var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
    var context = this;

    for (var i = 0, l = methods.length; i < l; i++) {
      context[methods[i]] = context[methods[i]].bind(context);
    }

    if (navigator.userAgent.indexOf('Windows Phone') >= 0) {
      layer.addEventListener('mouseover', this.onMouse, true);
      layer.addEventListener('mousedown', this.onMouse, true);
      layer.addEventListener('mouseup', this.onMouse, true);
    }

    layer.addEventListener('click', this.onClick, true);
    layer.addEventListener('touchstart', this.onTouchStart, false);
    layer.addEventListener('touchmove', this.onTouchMove, false);
    layer.addEventListener('touchend', this.onTouchEnd, false);
    layer.addEventListener('touchcancel', this.onTouchCancel, false);

    // Hack to bypass Android browser onclick delay with Event listeners
    if (typeof layer.onclick === 'function') {
      oldOnClick = layer.onclick;
      layer.addEventListener('click', function(event) {
        oldOnClick(event);
      }, false);
      layer.onclick = null;
    }
  }

  FastClick.prototype.needsClick = function(target) {
    switch (target.nodeName.toLowerCase()) {
      case 'button':
      case 'select':
      case 'textarea':
        if (target.disabled) {
          return true;
        }
        break;
      case 'input':
        // Ignora input per evitare problema doppio tap focus
        return true;
      case 'label':
      case 'iframe':
      case 'video':
        return true;
    }
    return /\bneedsclick\b/.test(target.className);
  };

  FastClick.prototype.needsFocus = function(target) {
    switch (target.nodeName.toLowerCase()) {
      case 'textarea':
        return true;
      case 'select':
        return navigator.userAgent.indexOf('Android') === -1;
      case 'input':
        switch (target.type) {
          case 'button':
          case 'checkbox':
          case 'file':
          case 'image':
          case 'radio':
          case 'submit':
            return false;
        }
        return !target.disabled && !target.readOnly;
      default:
        return /\bneedsfocus\b/.test(target.className);
    }
  };

  FastClick.prototype.sendClick = function(targetElement, event) {
    var clickEvent, touch;

    if (document.activeElement && document.activeElement !== targetElement) {
      document.activeElement.blur();
    }

    touch = event.changedTouches[0];

    clickEvent = document.createEvent('MouseEvents');
    clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1,
      touch.screenX, touch.screenY, touch.clientX, touch.clientY,
      false, false, false, false, 0, null);
    clickEvent.forwardedTouchEvent = true;
    targetElement.dispatchEvent(clickEvent);
  };

  FastClick.prototype.determineEventType = function(targetElement) {
    return navigator.userAgent.indexOf('Android') !== -1 &&
      targetElement.tagName.toLowerCase() === 'select' ? 'mousedown' : 'click';
  };

  FastClick.prototype.focus = function(targetElement) {
    var length;

    if (navigator.userAgent.indexOf('iP(ad|hone|od)') !== -1 &&
        targetElement.setSelectionRange &&
        targetElement.type.indexOf('date') !== 0 &&
        targetElement.type !== 'time' &&
        targetElement.type !== 'month') {
      length = targetElement.value.length;
      targetElement.setSelectionRange(length, length);
    } else {
      targetElement.focus();
    }
  };

  FastClick.prototype.onTouchStart = function(event) {
    if (event.targetTouches.length > 1) {
      return true;
    }

    this.trackingClick = true;
    this.trackingClickStart = event.timeStamp;
    this.targetElement = event.targetTouches[0].target;
    this.touchStartX = event.targetTouches[0].pageX;
    this.touchStartY = event.targetTouches[0].pageY;

    return true;
  };

  FastClick.prototype.onTouchMove = function(event) {
    if (!this.trackingClick) {
      return true;
    }

    if (Math.abs(event.targetTouches[0].pageX - this.touchStartX) > this.touchBoundary ||
        Math.abs(event.targetTouches[0].pageY - this.touchStartY) > this.touchBoundary) {
      this.trackingClick = false;
      this.targetElement = null;
    }

    return true;
  };

  FastClick.prototype.onTouchEnd = function(event) {
    if (!this.trackingClick) {
      return true;
    }

    this.trackingClick = false;

    if (this.needsClick(this.targetElement)) {
      return true;
    }

    event.preventDefault();
    this.sendClick(this.targetElement, event);

    return false;
  };

  FastClick.prototype.onTouchCancel = function() {
    this.trackingClick = false;
    this.targetElement = null;
  };

  FastClick.prototype.onClick = function(event) {
    if (this.trackingClick) {
      this.targetElement = null;
      this.trackingClick = false;
      return true;
    }

    return true;
  };

  FastClick.notNeeded = function(layer) {
    var metaViewport;
    var chromeVersion;
    var firefoxVersion;
    var isAndroid = navigator.userAgent.indexOf('Android') !== -1;
    var isIOS = /iP(ad|hone|od)/.test(navigator.userAgent);
    var isWindowsPhone = navigator.userAgent.indexOf('Windows Phone') >= 0;

    if (typeof window.ontouchstart === 'undefined') {
      return true;
    }

    chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

    if (isAndroid && chromeVersion >= 31) {
      metaViewport = document.querySelector('meta[name=viewport]');

      if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
        return true;
      }
    }

    if (isIOS) {
      var iOSVersionMatch = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
      var majorVersion = iOSVersionMatch ? parseInt(iOSVersionMatch[1], 10) : 0;

      if (majorVersion >= 10) {
        metaViewport = document.querySelector('meta[name=viewport]');

        if (metaViewport && metaViewport.content.indexOf('user-scalable=no') !== -1) {
          return true;
        }

        if (document.documentElement.scrollWidth <= window.outerWidth) {
          return true;
        }
      }
    }

    if (isWindowsPhone) {
      return true;
    }

    return false;
  };

  FastClick.attach = function(layer, options) {
    return new FastClick(layer, options);
  };

  if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {
    define(function() {
      return FastClick;
    });
  } else if (typeof module !== 'undefined' && module.exports) {
    module.exports = FastClick;
  } else {
    window.FastClick = FastClick;
  }
}();
